import { NxGridModule } from "@allianz/ng-aquila/grid";
import {
  IPaginationTexts,
  NX_PAGINATION_TEXTS,
} from "@allianz/ng-aquila/pagination";
import { NxPaginationModule } from "@allianz/ng-aquila/pagination";
import { CommonModule } from "@angular/common";
import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LayoutBreakPointsService } from "src/app/shared/services/layout-break-points.service";

let myPaginationTexts: IPaginationTexts = {
  previous: "",
  next: "",
  ofLabel: "of",
  ariaLabel: "",
};

@Component({
  selector: "app-search-form-pagination-custom-mb",
  templateUrl: "./search-form-pagination-custom-mb.component.html",
  styleUrls: ["./search-form-pagination-custom-mb.component.scss"],
  providers: [{ provide: NX_PAGINATION_TEXTS, useValue: myPaginationTexts }],
  standalone: true,
  imports: [CommonModule, NxGridModule, NxPaginationModule],
})
export class SearchFormPaginationCustomMbComponent
  implements OnInit, OnChanges
{
  private readonly destroyRef = inject(DestroyRef);

  @Input() public data: any[] = [];
  @Input() public searchInput: any;
  @Output() public perPage: EventEmitter<number> = new EventEmitter<number>();
  @Output() public curPage: EventEmitter<number> = new EventEmitter<number>();

  protected desktopView: boolean = false;
  protected count: number = 0;
  protected curPageSelected: number = 1;
  protected perPageSelected: number = 10;

  constructor(
    private readonly layoutBreakpointService: LayoutBreakPointsService,
  ) {}

  ngOnInit(): void {
    this.count = this.data?.length ?? 0;
    this.layoutBreakpointService
      .subscribeLayoutChanges()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.desktopView = this.layoutBreakpointService.renderDesktop();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.data?.currentValue) {
      this.count = (changes.data.currentValue as any[]).length;
    }

    if (changes?.searchInput) {
      this.curPageSelected = 1;
    }
  }

  protected prevPage(): void {
    this.curPageSelected--;
    this.curPage.emit(this.curPageSelected);
  }

  protected nextPage(): void {
    this.curPageSelected++;
    this.curPage.emit(this.curPageSelected);
  }

  protected goToPage(n: number): void {
    this.curPageSelected = n;
    this.curPage.emit(n);
  }
}
